import { createFileRoute, useRouter } from '@tanstack/react-router';
import { ShieldOffIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, EmptyState, PageShell } from '@noor/ui';

/**
 * Where the root permission guard sends a route the current user may not
 * open. Carries no permission itself. The shell (and its permission-filtered
 * sidebar) stays, so the user can move on to a section they do hold.
 */
export const Route = createFileRoute('/forbidden')({
  component: ForbiddenRoute,
});

function ForbiddenRoute() {
  const { t } = useTranslation('common');
  const router = useRouter();
  return (
    <PageShell>
      <EmptyState
        icon={ShieldOffIcon}
        title={t('access.forbiddenTitle')}
        description={t('access.forbiddenDescription')}
        action={
          <Button variant="outline" onClick={() => router.history.back()}>
            {t('access.goBack')}
          </Button>
        }
      />
    </PageShell>
  );
}
